import { createTheme } from '@mui/material/styles';

/**
 * MUI theme wired to this app's dark/light look, instead of MUI's own
 * default light palette. Without this, MUI components (Paper, TextField,
 * Table, Chip, ...) render with a hardcoded white background regardless of
 * the app's own dark/light theme toggle.
 *
 * NOTE: palette.* values must be real, parseable colors (hex/rgb/hsl), NOT
 * `var(--x)` CSS custom-property strings. MUI's palette engine runs color
 * math on these (contrast-text calc, tonal shade generation, hover/focus
 * alpha overlays via decomposeColor/alpha) and throws "MUI error #9" on a
 * string it can't decompose. These mirror the literal values in App.css's
 * `:root` / `[data-theme='dark']` — keep in sync if App.css changes.
 * CSS vars ARE safe inside components.styleOverrides below, since those are
 * plain DOM style strings never passed through MUI's color utilities.
 */
const TOKENS = {
  light: {
    bg: '#e7ebef', card: '#ffffff', ink: '#14181f', ink2: '#4a5560',
    line: '#d6dce3', primary: '#0e7a82',
  },
  dark: {
    bg: '#0b191f', card: '#162b33', ink: '#e4edf0', ink2: '#b7c9cf',
    line: '#234049', primary: '#4fb3bc',
  },
};

export function buildMuiTheme(mode) {
  const t = mode === 'dark' ? TOKENS.dark : TOKENS.light;
  return createTheme({
    palette: {
      mode,
      background: { default: t.bg, paper: t.card },
      text: { primary: t.ink, secondary: t.ink2 },
      primary: { main: t.primary },
      divider: t.line,
    },
    typography: { fontFamily: 'var(--font-sans)' },
    shape: { borderRadius: 10 },
    components: {
      // MUI tints dark-mode Paper with a translucent white overlay per
      // elevation level — that overlay fights our own --card color, so drop it.
      MuiPaper: { styleOverrides: { root: { backgroundImage: 'none' } } },
      MuiTableCell: { styleOverrides: { root: { borderColor: 'var(--line)' } } },
    },
  });
}
